import { sizes } from 'variables/breakpoint';
import useMediaQuery from './useMediaQuery';

export default function useIsAboveBreakPoint(size: sizes) {
    return useMediaQuery(`(min-width: ${size}px)`);
}
